import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { router } from "./router.tsx";
import { RouterProvider } from "react-router";
import "./i18n";
import "shared/styles/global.css";

// Register Service Worker for PWA
// IMPORTANT: never register SW during local dev; it breaks Vite module requests.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(registrationError => {
      console.error("SW registration failed: ", registrationError);
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
